export default __webpack_public_path__ + "static/media/Stalker's Gloves of the Hidden Tomb.e4e96ef5.jpg";